import router from '../router'
import partnerUserService from '../service/partner'

let domain = window.location.host
if (process.env.NODE_ENV != 'production') {
    if (process.env.VUE_APP_PARTNER) {
        domain = process.env.VUE_APP_PARTNER
    } else {
        domain = 'localhost'
    }
}

const partnerUser = JSON.parse(localStorage.getItem('partnerUser'));
const state = partnerUser
    ? {
        partner: '',
        status: {
            loggedIn: true
        },
        partnerUser,
        activeTab: "points"
    }
    : {
        partner: '',
        status: {},
        activeTab: 'points'
    };


const actions = {
    login({ commit }, { email, password }) {
        commit('loginRequest', { email });
        partnerUserService.auth(domain, email, password)
            .then(partnerUser => {
                commit('loginSuccess', partnerUser);
                router.push('/customer');
            }).catch(() => {
                commit('loginFailure')
            })
    },
    logout({ commit }) {
        localStorage.removeItem('partnerUser')
        router.push('/login')
        commit('logout');
    },
    loadPartner({ commit }) {
        return partnerUserService.getPartnerSummary(domain).then(partner => {
            localStorage.setItem('preferences', JSON.stringify(partner.preferences));
            commit('setPartner', partner)
        }).catch(e => {
            console.log(e)
            return partnerUserService.getCustomerSummary(domain).then(partner => {
                localStorage.setItem('preferences', JSON.stringify(partner.preferences));
                commit('setPartner', partner)
            })
        })
    },
};
const mutations = {
    setPartner(state, partner) {
        state.partner = partner
    },
    loginRequest(state, partnerUser) {
        state.status = { loggingIn: true };
        state.partnerUser = partnerUser;
    },
    loginSuccess(state, data) {
        state.status = { loggedIn: true };
        state.partnerUser = {
            id: data.id,
            name: data.name,
            surname: data.surname,
            role: data.role
        };
    },
    loginFailure(state) {
        state.status = {};
        state.partnerUser = null;
    },
    logout(state) {
        state.status = {};
        state.partnerUser = null;
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
